import { render, staticRenderFns } from "./Catalog-Results-Card.vue?vue&type=template&id=2ec7d332&lang=pug"
import script from "./Catalog-Results-Card.vue?vue&type=script&setup=true&lang=ts"
export * from "./Catalog-Results-Card.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Catalog-Results-Card.vue?vue&type=style&index=0&id=2ec7d332&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports